<div class="wrapper">
  <router-outlet></router-outlet>

  <ngx-spinner bdColor = "rgba(0,0,0,0.65)" size = "medium" color = "#28a745" type = "line-scale" [fullScreen] = "true">
    <p class="spinner-text">Procesando...</p>
  </ngx-spinner>


</div>